import { gql } from "@apollo/client/core";

export default gql`
    fragment PreventionCategory_Minimal on PreventionCategory {
        id
        description
        title
    }
`
